/**
 * facebookLogin.js
 * [Managed by LoginComponent]
 * [Housed in login tab]
 * Takes care of loggind users with facebook.
 * @author Juhi Sharma
 */
import React from 'react';
import BaseComponent from '../../BaseComponent';
import LocUtils from '../../../util/localization/LocUtils'
import '../../../../styles/generic.css'
import './Login.css'
import ServiceLocator from '../../../ServiceLocator';
import Button from '../buttons/Buttons';

class FacebookLogin extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            engaged: false
        };

        // Subscription to turn of the field editing 
        this.onEngageFinish = this.onEngageFinish.bind(this);
        if (!ServiceLocator.Events.isSubscribed("ZDC_ACCOUNT_REGISTER", this.onEngageFinish)) ServiceLocator.Events.subscribe("ZDC_ACCOUNT_REGISTER", this.onEngageFinish);
        if (!ServiceLocator.Events.isSubscribed("ZDC_FB_ACCOUNT_REGISTER", this.onEngageFinish)) ServiceLocator.Events.subscribe("ZDC_FB_ACCOUNT_REGISTER", this.onEngageFinish);

        this.loginFBHandler = props.loginFBHandler;
        this.loginGoogleHandler = props.loginGoogleHandler;
    }

    componentDidMount() {
        ServiceLocator.ZTrack.Cast({
            counter: "ui",
            kingdom: "load",
            phylum: "signup"
        })
    }

    /** Subscription handler */
    onEngageFinish(evt) {
        this.setState({
            engaged: false
        })
    }

    componentWillUnmount() {
        ServiceLocator.Events.unsubscribe("ZDC_ACCOUNT_REGISTER", this.onEngageFinish);
        ServiceLocator.Events.unsubscribe("ZDC_FB_ACCOUNT_REGISTER", this.onEngageFinish);
    }

    render() {
        return (
            <div className="col-sm-12 col-12 col-md-6 col-lg-6 login-left-splash-panel" id="signup_fb_pane">
                <img
                    className="login-left-splash-image"
                    src={process.env.REACT_APP_ASSET_PATH + "/dialogs/login/login_pane1_without_facebook.png"}
                    alt=""
                />
                <div className="login-left-splash-footer">
                    {this.props.isGoogleSSOActive &&
                    <div className="mb-2 text-center">
                        <Button
                            onClick={() => {
                                this.loginGoogleHandler();
                            }}
                            extraClass="h6"
                            severity="link"
                            message={LocUtils.T("login.google_login_text")}
                        />
                    </div>}
                    <p className="login-left-splash-footer-text">{LocUtils.T("login.signup_button_header")}</p>
                    <Button
                        onClick={() => {
                            ServiceLocator.ZTrack.Cast({
                                counter: "dialog",
                                kingdom: "click",
                                phylum: "emailLogin",
                                zClass: "signup",
                                family: "zdc_register",
                                value: ServiceLocator.SocialNetworkManager.Me.Identity.getDeviceID()
                            });
                            this.props.parentSwitchTabHandle("signup")
                        }}
                        extraClass="login-left-splash-footer-link"
                        severity="link"
                        message={LocUtils.T("login.signup_confirm_deny")}
                    />
                </div>
            </div>
        )
    }
}

export default FacebookLogin;